import vue from 'vue'
import toastComponent from '../components/dialog/msg.vue'

const ToastConstructor = vue.extend(toastComponent)

function showToast({ text, msg, type, duration = 2000 }, dom) {
	const toastDom = new ToastConstructor({
		el: document.createElement('div'),
		data() {
			return {
				isShow: true, // 是否显示
				text: text || msg, // 文本内容
				status: type // 类型
			}
		}
	})
	// 添加节点
	let oldPosition = ''
	let mainbox = document.body.getElementsByClassName('right')
	if (dom) {
		toastDom.$el.style.position = 'absolute'
		oldPosition = dom.style.position
		dom.style.position = 'relative'
		dom.appendChild(toastDom.$el)
	} else if (mainbox && mainbox[0]) {
		toastDom.$el.style.position = 'absolute'
		oldPosition = mainbox[0].style.position
		mainbox[0].style.position = 'relative'
		mainbox[0].appendChild(toastDom.$el)
	} else {
		document.body.appendChild(toastDom.$el)
	}
	// 过渡时间
	setTimeout(() => {
		toastDom.isShow = false
		if (dom) {
			dom.style.position = oldPosition
		} else if (mainbox && mainbox[0]) {
			mainbox[0].style.position = oldPosition
		}
	}, duration)
}

export default showToast
